import { render } from "./deliveryMenu.vue?vue&type=template&id=424fd910"
import script from "./deliveryMenu.vue?vue&type=script&lang=js"
export * from "./deliveryMenu.vue?vue&type=script&lang=js"

import "./deliveryMenu.vue?vue&type=style&index=0&id=424fd910&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__